import { ReactElement, useCallback, memo } from 'react';

import ComminSoonBadge from '../ComminSoonBadge';
import NewFeatureBagde from '../NewFeatureBagde';

import { NavigationListItemProps } from './types';
import NavigationListItemButtonAction from './ListItemButtonAction';
import {
  NavigationListItemContainer,
  NavigationListItemIcon,
  NavigationListItemText,
} from './styles';

const NavigationListItem = ({
  id,
  label,
  icon: Icon,
  path,
  commingSoon,
  newActiveForVersion,
  validSubscriptionFeature,
  isActive = false,
  onClick,
}: NavigationListItemProps): ReactElement => {
  const handleClick = useCallback(() => {
    onClick?.({ id, path });
  }, [onClick, id, path]);

  return (
    <NavigationListItemContainer>
      <NavigationListItemButtonAction
        validSubscriptionFeature={validSubscriptionFeature}
        onClick={handleClick}
        isActive={isActive}
        disabled={commingSoon}
      >
        <NavigationListItemIcon>{Icon}</NavigationListItemIcon>

        <NavigationListItemText
          primary={label}
          primaryTypographyProps={{ variant: 'inherit' }}
        />

        {commingSoon && <ComminSoonBadge />}

        {newActiveForVersion && (
          <NewFeatureBagde
            activeForVersion={newActiveForVersion}
            sx={{ marginRight: 0 }}
          />
        )}
      </NavigationListItemButtonAction>
    </NavigationListItemContainer>
  );
};

export default memo(NavigationListItem);
